import { ZodError, ZodSchema, z } from 'zod';

import { isNullOrUndefined } from './general-utils';

export const safeParseZod = <Type extends ZodSchema>(
  schema: Type,
  obj: object | undefined,
) => {
  if (isNullOrUndefined(obj)) {
    return undefined;
  }

  try {
    const mappedObject = schema.parse(obj) as z.infer<typeof schema>;
    return mappedObject;
  } catch (error) {
    if (error instanceof ZodError) {
      console.error(error.errors);
    } else {
      console.error(error);
    }
    return undefined;
  }
};

export const parseStringToBoolean = z.preprocess(value => {
  if (value == null || value === '') {
    return value;
  }

  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'number') {
    return value !== 0;
  }

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();

    if (['true', '1', 'yes', 'on'].includes(normalized)) {
      return true;
    }

    if (['false', '0', 'no', 'off'].includes(normalized)) {
      return false;
    }
  }

  return value;
}, z.boolean().nullable().optional());

export const parseStringToNumber = z.preprocess(value => {
  if (value == null || value === '') {
    return value;
  }

  if (typeof value === 'number') {
    return value;
  }

  if (typeof value === 'string') {
    const normalized = value.trim();

    if (normalized === '') {
      return value;
    }

    const num = Number(normalized);
    return Number.isNaN(num) ? value : num;
  }

  return value;
}, z.number().nullable().optional());
